<template>
  <div id="app" v-if="appShow">
    <router-view />
  </div>
</template>

<script>
import { getCookie } from '@/tools'
import { Hotupdate, updateTip, needUpdate } from '@/utils/updeteServe.js'
export default {
  name: 'App',
  data() {
    return {
      appShow: false,
    }
  },

  methods: {
    // 跟新系统
    updateServe() {
      // this.$store.commit('setUpdateServe', false)
      // location.reload()
    },

    nowUpdateServe() {
      // this.$store.commit('setUpdateServe', false)
    },
  },

  async created() {
    Hotupdate(this)
    if (getCookie('Token')) {
      await this.$store.dispatch('GetUserInfo')
    }
    
    if(this.$store.getters['jxStorePick/allCity'].length === 0) this.$store.dispatch('jxStorePick/getCity')  // 获取城市信息
    this.appShow = true
    let loading = document.querySelector('.yz-loading')
    let mask = document.querySelector('.yz-mask')
    if (loading) {
      setTimeout(() => {
        loading.style.display = 'none'
        mask.style.display = 'none'
      }, 200)
    }
    // 判断页面是否进入后台
    document.addEventListener('visibilitychange', async () => {
      if (document.hidden === false) {
        const willupdate = await needUpdate()
        if (willupdate) {
          updateTip(this)
        }
      }
    })
  },
}
</script>

<style lang="scss">
@import './assets/scss/global.scss';
kbd {
  align-items: center;
  background: linear-gradient(-225deg, #d5dbe4, #f8f8f8);
  border-radius: 2px;
  box-shadow: inset 0 -2px 0 0 #cdcde6, inset 0 0 1px 1px #fff,
    0 1px 2px 1px rgba(30, 35, 90, 0.4);
  display: flex;
  height: 18px;
  justify-content: center;
  margin-right: 0.5em;
  margin-left: 0.5em;
  padding: 0 0 1px;
  border: 0;
  width: 20px;
}

.ctrl {
  width: 36px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue